export default __webpack_public_path__ + "static/media/services2.b25431a0.jpg";